import { useEffect, useState } from 'react'

import Overlay from './Overlay'
import Spinner from './spinner'

type Props = {
  isLoading: boolean
  phrases: string[]
  overlayType?: 'local' | 'global'
}

const LoadingOverlay = ({ isLoading, overlayType, phrases }: Props) => {
  const [currentPhraseIndex, setCurrentPhraseIndex] = useState(0)

  useEffect(() => {
    if (isLoading) {
      const interval = setInterval(() => {
        setCurrentPhraseIndex((prev) =>
          phrases.length - 1 > prev ? prev + 1 : 0
        )
      }, 5000)
      return () => clearInterval(interval)
    } else {
      setCurrentPhraseIndex(0)
    }
  }, [isLoading, phrases.length])

  return isLoading ? (
    <Overlay bgColor="bg-white" type={overlayType}>
      <div className="flex flex-col justify-center items-center text-white text-3xl ">
        <Spinner />
        <div className="text-coolGray-900 text-base font-medium mt-4">
          Generating magic
        </div>
        <div className="text-coolGray-700 text-base mt-5">
          {phrases[currentPhraseIndex]}
        </div>
      </div>
    </Overlay>
  ) : null
}

export default LoadingOverlay
